import { styled as styling } from "@mui/material/styles";
import Link from "next/link";
import Color from "../../../assets/colors";

export const CardStyled = styling("div")({
  borderRadius: "1rem",
  border: `1.5px solid ${Color.grey}`,
  height: "20rem",
  width: "100%",

  transition: "all 0.15s ease-in-out",

  "@media (min-width: 1280px)": {
    "&:hover": {
      border: `1.5px solid ${Color.black}`,
    },
  },

  "@media (max-width: 1280px)": {
    minWidth: "320px",
  },
});

export const CompanyBanner = styling("div")({
  backgroundPosition: "center",
  backgroundSize: "cover",

  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-end",
  height: "13.5rem",
  borderRadius: "0.9rem 0.9rem 0 0",
});

export const OutlineButton = styling(Link)({
  textTransform: "capitalize",
  textDecoration: "none",
  textAlign: "center",
  color: "rgba(0, 0, 0, 0.87)",
  fontSize: "0.875rem",
  fontWeight: "500",
  padding: "0.875rem 2rem",
  borderRadius: "0.5rem",

  backgroundColor: Color.white,
  border: `1.5px solid ${Color.black}`,

  transition: "all 0.075s ease-in-out",

  "@media (min-width: 1280px)": {
    "&:hover": {
      border: `1px solid ${Color.black}`,
      boxShadow: "2px 2px 0px rgba(0, 0, 0, 1)",
      transform: "translate(-2px, -2px)",
      cursor: "pointer",
    },
  },

  "@media (max-width: 640px)": {
    width: "100%",
  },
});
